<template>
  <div class="c-event-messaging c-content">
    <component v-for="(type, index) in JSON.parse(messageTypes)" :key="index" :is="messageComponentName(type)" :content="messageContent(type)"></component>
  </div>
</template>

<script>
import Membership from "./messages/Membership"
import Amex from "./messages/Amex"
import Youth from "./messages/Youth"
import Generic from "./messages/Generic"
import Fridayrush from "./messages/Fridayrush"
import { mapActions } from 'vuex'
import {EventBus} from "../event-bus"


export default {
  name: "App",
  props: ['messageTypes', 'eventId'],
  components: {
    Membership,
    Amex,
    Youth,
    Fridayrush,
    Generic,
  },
  data() {
    return {
      eventDataLoaded: false,
      isLoading: true,
    }
  },
  mounted() {
    this.$store.commit('eventId', parseInt(this.eventId))
    this.$store.commit('loggedIn', window.isLoggedIn)
    if (document.querySelector('[data-booking-button-type="picker"]')) {
      this.eventData().then((data) => {
        EventBus.$emit('eventData:loaded')
      })
    } else if (document.querySelector('[data-booking-button-type="third-party"]')) {
      this.thirdPartyData().then((data) => {
        EventBus.$emit('thirdPartyData:loaded')
      })
    } else {
      // No MOS check needed
      EventBus.$emit('noDataRequired')
    }

  },
  methods: {
    ...mapActions({
      eventData: 'fetchEventData',
      thirdPartyData: 'fetchThirdPartyData'
    }),
    currentModeOfSale() {
      if (window.ModeOfSaleId !== window.env.DEFAULT_MOS) {
        return parseInt(window.ModeOfSaleId)
      }
      return parseInt(window.env.DEFAULT_MOS)
    },
    messageComponentName(type) {
      return type.slice(0, 1).toUpperCase() + type.slice(1, type.length)
    },
    messageContent(type) {
      const messages = window.messaging || []

      if (Object.keys(messages).length > 0 && Object.keys(messages).includes(type)) {
        return messages[type]
      }
    }
  }
}
</script>
